





































































import { EventBus } from '@/event-bus.js';

import Vue from "vue";
import {
  checklistPostReq,
} from "@/services/checklist.service";


export default {
  props: ["comp_state"],
  data() {
    return {
      main_comp1: null, 
      main_comp2: null, 
      main_comp3: null, 
      main_comp4: null,
      main_comp5: null,
      main_comp6: null,
      dialog1: false, 
    };
  },
  components: {},
  mounted() {
    EventBus.$on('component_closed', this.componentClosedHandler);
    EventBus.$on('entry_added', this.addedHandler);
    EventBus.$on('comps_changed', this.compsChangedHandler);
    EventBus.$on('path_changed', this.pathChangedHandler);

    if (this.$store.state.initParams.comp && this.$store.state.initParams.comp.length > 2) {
      // Komponenten wählen
      this["main_comp1"] = this.$store.state.initParams.comp
      this.selCmp(1, true)
    }
  },
  destroyed() {
    this.$store.state.cl_components_2 = []
    this.$store.state.cl_components_3 = []
    this.$store.state.cl_components_4 = []
    this.$store.state.cl_components_5 = []
    this.$store.state.cl_components_6 = [] 
    EventBus.$off('component_closed', this.addedHandler);
    EventBus.$off('entry_added', this.addedHandler);
    EventBus.$off('path_changed', this.pathChangedHandler);
  },
  methods: {
    exportCsv(item) {

      this.dialog1 = true;
      checklistPostReq("inout-export", item).then((resp) => {
        this.dialog1 = false;
        console.log(resp);

        this.snackbar_bottom = true;
        this.snackbar_bottom_text = "The checklist was exported successfully.";

        var tempLink = document.createElement("a");
        tempLink.href =
          Vue.prototype.$apiBase + "/fileDownload?file=" + resp.item.filename;
        tempLink.setAttribute("download", "checkliste.csv");
        tempLink.click();
      });

    },
    pathChangedHandler: function(d) {
      console.log("pathChangedHandler", this.$store.state.initParams)
      this["main_comp1"] = this.$store.state.initParams.comp
      this.selCmp(1, true)
    },
    compsChangedHandler: function(d) {
      this.$store.state.initParams["comp"+d.level] = "c"
      // Check, ob es eine ID zu einer Komponenten auf der nächsten Ebene in der URL gibt. 
      if (this.$store.state.initParams["comp"+(parseInt(d.level)+1)] && this.$store.state.initParams["comp"+(parseInt(d.level)+1)].length > 2) {
        this["main_comp"+(parseInt(d.level)+1)] = this.$store.state.initParams["comp"+(parseInt(d.level)+1)]
        this.selCmp((parseInt(d.level)+1), true)
      }
    },
    refreshCmp: function(level, deeplink) { 
      if (this["main_comp"+level]) {

        for (let i = level+1 ; i < 7 ; i++) {
          this.$store.state["cl_components_"+i] = [] 
          this["main_comp"+i] = null
        }
        this.$emit("selectCmp", {cmp_uid: this["main_comp"+level], level: level, deeplink: deeplink});

      }
    },
    selCmp: function(level, deeplink) { 
      this.$emit("selectCmp", {cmp_uid: this["main_comp"+level], level: level, deeplink: deeplink});
    },
    createAct: function () {
      this.$emit("createAct", { type: "component", level: 1 });
    },
    openCompTree: function() {
      window.open("/checklist-tree/"+this.$store.state.cl_uid)
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type });
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    addedHandler: function (data) {
      //if (!data.create) { // Dupliziert
      if (data.type == 'component') {
        this["main_comp"+data.level] = data.entry_uid
        this.$emit("selectCmp", {cmp_uid: data.entry_uid, level: data.level});
      }
    },
    componentClosedHandler: function (entry) {
      if (entry.level > 1) {
        this.selCmp( entry.level-1 )

        if (entry.level-1 == 5) {
          this.main_comp6 = null
        }
        if (entry.level-1 == 4) {
          this.main_comp5 = null
          this.main_comp6 = null
        }
        if (entry.level-1 == 3) {
          this.main_comp4 = null
          this.main_comp5 = null
          this.main_comp6 = null
        }
        if (entry.level-1 == 2) {
          this.main_comp3 = null
          this.main_comp4 = null
          this.main_comp5 = null
          this.main_comp6 = null
        }
        if (entry.level-1 == 1) {
          this.main_comp2 = null
          this.main_comp3 = null
          this.main_comp4 = null
          this.main_comp5 = null
          this.main_comp6 = null
        }
      }
    }
  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
    copy_entry_level() {
      if ( this.$store.state.copy_entry &&  
           ( this.$store.state.copy_entry.type == 'subcomponent' || this.$store.state.copy_entry.type == 'component') ) {
             if (this.$store.state.copy_entry.level == 2 ) {
               return 2
             }
             if (this.$store.state.copy_entry.level == 3 && this.cld_components_2.length > 0 && this.main_comp2) {
               return 3
             }
             if (this.$store.state.copy_entry.level == 4 && this.cld_components_3.length > 0 && this.main_comp3) {
               return 4
             }
             if (this.$store.state.copy_entry.level == 5 && this.cld_components_4.length > 0 && this.main_comp4) {
               return 5
             }
             if (this.$store.state.copy_entry.level == 5 && this.cld_components_5.length > 0 && this.main_comp5) {
               return 6
             }
           }
       return null
    },
    current_cld_uid() {
      return this.$store.state.cl_uid; 
    },
    copy_entry_name() {
      return this.$store.state.copy_entry && this.$store.state.copy_entry.name
    },                
    copy_entry_level1() {
      return this.$store.state.copy_entry &&  
             this.$store.state.copy_entry.type == 'component' && 
             this.$store.state.copy_entry.level == 1
    }, 
    cld_components: function() {
      return this.$store.state.cl_components;
    },
    cld_components_2: function() {
      return this.$store.state.cl_components_2;
    },
    cld_components_3: function() {
      return this.$store.state.cl_components_3;
    },
    cld_components_4: function() {
      return this.$store.state.cl_components_4;
    },
    cld_components_5: function() {
      return this.$store.state.cl_components_5;
    },
    cld_components_6: function() {
      return this.$store.state.cl_components_6;
    }
  }
};
